import palette from "./palette";
import typography from "./typography";

const myTheme = {
	...palette,
	...typography,
};

export default myTheme;
